import React, { useState } from "react";

export default function YouTube({
	videoId,
	title = "YouTube video",
	autoplay = false,
	poster = "hqdefault",
	className,
	rel = 0,
	allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
	allowFullScreen = true,
}) {
	const [activated, setActivated] = useState(false);

	const embedSrc =
		activated &&
		`https://www.youtube-nocookie.com/embed/${videoId}?rel=${rel}&autoplay=1`;

	return (
		<div
			className={className}
			style={{
				position: "relative",
				paddingBottom: "56.25%",
				height: 0,
				overflow: "hidden",
				cursor: "pointer",
			}}
			onClick={() => {
				console.log("click");
				setActivated(true);
			}}
			role="button"
			aria-label="Play video"
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					setActivated(true);
				}
			}}
		>
			{/* Iframe always present */}
			{activated && (
				<iframe
					src={embedSrc}
					title={title}
					loading="lazy"
					referrerPolicy="strict-origin-when-cross-origin"
					allow={allow}
					allowFullScreen={allowFullScreen}
					style={{
						position: "absolute",
						inset: 0,
						width: "100%",
						height: "100%",
						border: 0,
					}}
				/>
			)}
			{!activated && (
				<>
					{/* Thumbnail */}
					<img
						src={`https://i.ytimg.com/vi/${videoId}/${poster}.jpg`}
						alt={title}
						loading="lazy"
						style={{
							position: "absolute",
							inset: 0,
							width: "100%",
							height: "100%",
							objectFit: "cover",
							cursor: "pointer",
						}}
					/>

					{/* Play overlay */}
					<div
						style={{
							position: "absolute",
							inset: 0,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							background: "rgba(0,0,0,0.25)",
						}}
					>
						<svg width="68" height="48" viewBox="0 0 68 48">
							<path
								className="fill"
								d="M66.52,7.74c-0.78-2.93-3.09-5.24-6.02-6.02C51.68,0,34,0,34,0S16.32,0,7.5,1.72C4.57,2.5,2.26,4.81,1.48,7.74 C0,13.16,0,24,0,24s0,10.84,1.48,16.26c0.78,2.93,3.09,5.24,6.02,6.02C16.32,48,34,48,34,48s17.68,0,26.5-1.72 c2.93-0.78,5.24-3.09,6.02-6.02C68,34.84,68,24,68,24S68,13.16,66.52,7.74z"
								fill="#f00"
							></path>
							<path d="M 45,24 27,14 27,34" fill="#fff"></path>
						</svg>
					</div>
				</>
			)}
		</div>
	);
}
